/** Currency display helpers — local to the customizer wizard. */

const SYMBOLS: Record<string, string> = {
  USD: '$',
  MXN: 'MX$',
  EUR: '€',
  GBP: '£',
  RON: 'lei ',
};

/** Symbol for a currency code (trailing space kept for prefix codes like "lei "). */
export const currencySymbol = (code: string): string => SYMBOLS[code] ?? (code ? `${code} ` : '');

const CURRENCY_NAMES: Record<string, string> = {
  USD: 'US dollar',
  EUR: 'Euro',
  GBP: 'British pound',
  RON: 'Romanian leu',
  MXN: 'Mexican peso',
};

/** Long currency name; falls back to the ISO code when unknown. */
export const currencyName = (code: string): string => CURRENCY_NAMES[code] ?? code;

/** Format a domain's price for the suggestion row, e.g. "2,000$/year".
 *  Returns `{ label, free }` — `free` drives the green styling + "Free" copy. */
export const formatDomainPrice = (price: number | undefined, currency: string): { label: string; free: boolean } => {
  if (!price || price <= 0) return { label: 'Free', free: true };
  const symbol = currencySymbol(currency).trim() || currency;
  return { label: `${price.toLocaleString('en-US')}${symbol}/year`, free: false };
};